import { render, staticRenderFns } from "./ContentPrivateConfList.vue?vue&type=template&id=0f46898e"
import script from "./ContentPrivateConfList.vue?vue&type=script&lang=js"
export * from "./ContentPrivateConfList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports